import { Button, Heading, Modal, Paragraph } from '@zillow/constellation-10';
import type { TourEvent } from '../../../../../../constants';
import { getEventToastDisplayDate } from '../../../../../../utils/formatTime';

type CancelTourConfirmationModalProps = {
  event: TourEvent;
  onClose: () => void;
  onCancelTourConfirmationClick: () => void;
};
const CancelTourConfirmationModal = ({
  event,
  onClose,
  onCancelTourConfirmationClick,
}: CancelTourConfirmationModalProps) => {
  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      body={
        <div data-testid="CancelTourConfirmationModal-Body">
          <Heading css={{ marginBottom: 'default' }} level={4} fontFamily="heading-alt">
            Cancel this tour?
          </Heading>
          <Paragraph css={{ marginBottom: 'tighter' }}>
            This will let {event.bookedByName} know that the tour scheduled for {getEventToastDisplayDate(event)} is
            canceled.
          </Paragraph>
        </div>
      }
      footer={
        <Button
          data-testid="CancelTourConfirmationModal-CancelBtn"
          emphasis="filled"
          onClick={onCancelTourConfirmationClick}
        >
          Cancel tour
        </Button>
      }
      size={{ base: 'fullScreen', lg: 'md' }}
    />
  );
};

export default CancelTourConfirmationModal;
